"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var event_1 = __importDefault(require("./utils/event"));
require("./utils/string-template2");
var CURRENT_LOCALE_CODE;
exports.CURRENT_LOCALE_CODE = CURRENT_LOCALE_CODE;
var CURRENT_LOCALE_BUNDLE = {};
exports.CURRENT_LOCALE_BUNDLE = CURRENT_LOCALE_BUNDLE;
var languageChangeEvent = new event_1.default();
exports.languageChangeEvent = languageChangeEvent;
function setLanguageBundle(localeCode, bundle) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            exports.CURRENT_LOCALE_CODE = CURRENT_LOCALE_CODE = localeCode;
            exports.CURRENT_LOCALE_BUNDLE = CURRENT_LOCALE_BUNDLE = bundle;
            languageChangeEvent.fire({ localeCode: localeCode, bundle: bundle });
            return [2 /*return*/, {
                    locale: CURRENT_LOCALE_CODE,
                    bundle: CURRENT_LOCALE_BUNDLE
                }];
        });
    });
}
exports.setLanguageBundle = setLanguageBundle;
function updateLanguageBundle(bundlePatch) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            exports.CURRENT_LOCALE_BUNDLE = CURRENT_LOCALE_BUNDLE = __assign({}, CURRENT_LOCALE_BUNDLE, bundlePatch);
            languageChangeEvent.fire({
                CURRENT_LOCALE_CODE: CURRENT_LOCALE_CODE,
                CURRENT_LOCALE_BUNDLE: CURRENT_LOCALE_BUNDLE,
                localeCode: CURRENT_LOCALE_CODE,
                bundle: CURRENT_LOCALE_BUNDLE
            });
            return [2 /*return*/, {
                    locale: CURRENT_LOCALE_CODE,
                    bundle: CURRENT_LOCALE_BUNDLE
                }];
        });
    });
}
exports.updateLanguageBundle = updateLanguageBundle;
function getString(key, replaceOptions) {
    var value = CURRENT_LOCALE_BUNDLE[key];
    // do replacement
    if (typeof value !== 'string') {
        return "Missing locale value (" + key + ")";
    }
    return replaceOptions ? value.template(replaceOptions) : value;
}
exports.getString = getString;
function getStringJSXReplaceOptions(key, replaceOptions) {
    var value = CURRENT_LOCALE_BUNDLE[key];
    //do replacement
    if (typeof value !== 'string') {
        return "Missing locale value (" + key + ")";
    }
    var returnString = value;
    Object.keys(replaceOptions).map(function (option) {
        returnString = returnString.replace(new RegExp(option, 'g'), replaceOptions[option]);
    });
    return returnString;
}
exports.getStringJSXReplaceOptions = getStringJSXReplaceOptions;
function keyExists(key) {
    return !!CURRENT_LOCALE_BUNDLE[key];
}
exports.keyExists = keyExists;
//# sourceMappingURL=translations.js.map